// Get text alignment class based on column config
export const getAlignmentClass = (column) => {
  const align = column.align || "left"; // Default to left alignment
  switch (align) {
    case "center":
      return "text-center";
    case "right":
      return "text-right";
    case "left":
    default:
      return "text-left";
  }
};

// Get justify content class for flex containers in headers
export const getJustifyClass = (column) => {
  const align = column.align || "left";
  switch (align) {
    case "center":
      return "justify-center";
    case "right":
      return "justify-end";
    case "left":
    default:
      return "justify-start";
  }
};
